export const SET_MARKETPLACE = "SET_MARKETPLACE";
export const SET_MARKETPLACE_SEARCH = "SET_MARKETPLACE_SEARCH";
export const SET_MARKETPLACE_SEARCH_LIST = "SET_MARKETPLACE_SEARCH_LIST";
export const SET_MARKETPLACE_SEARCH_RESET = "SET_MARKETPLACE_SEARCH_RESET";

export const SET_MARKETPLACE_FAVORITE = "SET_MARKETPLACE_FAVORITE";
export const SET_MARKETPLACE_RESET = "performance/SET_MARKETPLACE_RESET";
export const SET_MARKETPLACE_FAVORITE_LIST =
  "performance/SET_MARKETPLACE_FAVORITE_LIST";

export const SET_QTD_FILTER = "SET_QTD_FILTER";
export const SET_REMOVER_FILTER = "SET_REMOVER_FILTER";
export const SET_LIST_MODE = "SET_LIST_MODE";
export const SET_ACTIVE_FILTERS = "SET_ACTIVE_FILTERS";
export const CLEAR_ACTIVE_FILTERS = "MARKETPLACE_CLEAR_ACTIVE_FILTERS";
export const REMOVE_ACTIVE_FILTERS = "REMOVE_ACTIVE_FILTERS";
export const REMOVE_ACTIVE_FILTERS_INDEX = "REMOVE_ACTIVE_FILTERS_INDEX";
export const SET_PARTNER_INFO = "SET_PARTNER_INFO";
export const SET_PARTNER_SEARCH_TERM = "SET_PARTNER_SEARCH_TERM";
export const SET_RANGE_FILTER = "SET_RANGE_FILTER";
export const SET_TOGGLE_FILTER = "SET_TOGGLE_FILTER";
export const SET_SEARCH_CHARS = "SET_SEARCH_CHARS";
export const SET_MARKETPLACE_BY_FILTERS = "SET_MARKETPLACE_BY_FILTERS";
export const CLEAR_MARKETPLACE = "CLEAR_MARKETPLACE";
export const CLEAR_FILTER = "CLEAR_FILTER";
// export const SHOW_PORTFOLIO = "investmenSET_QTD_FILTERt/SHOW_PORTFOLIO";

// Start production and demo robot.
// export const START_BOT_DEMO = "investment/START_BOT_DEMO";
// export const START_BOT_PROD = "investment/START_BOT_PROD";
